import { backendAPI } from '../../helper/apis';

export function getScheduleDate(_id, params) {

  let url = `/lead/schedule/dates`
  if (_id) url = `/lead/schedule/date/${_id}`

  return backendAPI.get(url, { params });
}